import { render, staticRenderFns } from "./AssignAccount.vue?vue&type=template&id=32db8f72"
import script from "./AssignAccount.vue?vue&type=script&lang=ts"
export * from "./AssignAccount.vue?vue&type=script&lang=ts"
import style0 from "./AssignAccount.vue?vue&type=style&index=0&id=32db8f72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports